import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BasicGridviewComponent } from '../../components/basic-gridview/basic-gridview.component';
import { MaterialModule } from './material.module';
import { FormsModule } from '@angular/forms';
import { ListFilterPipe } from 'src/app/pipes/list-filter.pipe';
import { ErrorPageComponent } from '../../components/error-page/error-page.component';
import {RouterModule} from '@angular/router';
import { SsoLogoutComponent } from '../../components/sso-logout/sso-logout.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    RouterModule
  ],
  declarations: [
    BasicGridviewComponent,
    ErrorPageComponent,
    ListFilterPipe,
    SsoLogoutComponent
    
  ],
  exports: [
    BasicGridviewComponent,
    ErrorPageComponent,
    ListFilterPipe
  ]

})
export class SharedModule { }
